import AuthMessage from './AuthMessage';

export default AuthMessage;
